import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import media from 'src/styles/media';

import ScrollAnimation from 'components/ScrollAnimation';
import Header from 'src/components/Header';
import Container from 'src/components/Container';
import Tabs from './elements/Tabs';
import SelectBox from './elements/SelectBox';
import Floorplate from './elements/Floorplate';
import NextLine from 'src/components/NextLine';
import RegisterButton from 'src/components/RegisterButton';
import Popup from './elements/Popup';
import Thumbnails from './elements/Thumbnails';

import imgHero from 'src/assets/images/floorplans/hero.jpg';
import imgBgCircle from 'src/assets/images/bg-circle-grey.svg';

import dataFloorplans from 'src/data/floorplans';

const plans = ['Display by Type', 'Display by Level'];
const suiteLevels = ['2', '3', '4', '5', '6-13', '14', '15-18', '19', '20-32'];
const townHomeLevels = ['2', '3'];
const suiteType = ['Studio', '1 Bed', '2 Bed', '3 Bed', 'All'];
const townHomeType = [
  '3 Bed',
  <span>
    3 Bed + <br />
    Flex
  </span>,
  <span>
    3 Bed + <br />
    FR
  </span>,
  'All',
];

class Floorplans extends Component {
  state = {
    activeType: 0,
    activeDisplayType: 0,
    activeLevel: 0,
    activeSuiteType: 4,
    currentUnit: 'B10',
    activePopup: false,
  };

  handleIndex = index => {
    if (index) {
      this.setState({ activeLevel: 0, activeSuiteType: 3, activeType: index });
    } else {
      this.setState({ activeLevel: 0, activeSuiteType: 4, activeType: index });
    }
  };

  handleClickPlans = index => {
    this.setState({ activeDisplayType: index });
  };

  handleClickLevel = index => {
    this.setState({ activeLevel: index });
  };

  handleClickHomeType = index => {
    this.setState({ activeSuiteType: index });
  };

  handleClickFloorplan = unit => {
    this.setState({ currentUnit: unit, activePopup: true });
  };

  handlePrevFloorplan = unit => {
    let prevUnit = '';
    if (Object.keys(dataFloorplans).indexOf(unit) === 0) {
      prevUnit = Object.values(dataFloorplans)[
        Object.keys(dataFloorplans).length - 1
      ].id;
    } else {
      prevUnit = Object.values(dataFloorplans)[
        Object.keys(dataFloorplans).indexOf(unit) - 1
      ].id;
    }
    this.setState({ currentUnit: prevUnit, activePopup: true });
  };

  handleNextFloorplan = unit => {
    let nextUnit = '';
    if (
      Object.keys(dataFloorplans).indexOf(unit) ===
      Object.keys(dataFloorplans).length - 1
    ) {
      nextUnit = Object.values(dataFloorplans)[0].id;
    } else {
      nextUnit = Object.values(dataFloorplans)[
        Object.keys(dataFloorplans).indexOf(unit) + 1
      ].id;
    }
    this.setState({ currentUnit: nextUnit, activePopup: true });
  };

  handleClosePopup = () => this.setState({ activePopup: false });

  render() {
    return (
      <Root>
        <Header
          image={imgHero}
          smallText="Floorplans"
          largeText="Spacious Homes"
          darken
        />
        <ScrollAnimation>
          <Content>
            <BackgroundCircle
              src={imgBgCircle}
              top={'-150px'}
              right={'-150px'}
            />
            <BackgroundCircle
              src={imgBgCircle}
              bottom={'-210px'}
              right={'-60px'}
            />

            <StyledContainer>
              <h1 className="title">Select a floorplan from the list below</h1>
              <Tabs
                titles={['Suites', 'Townhouses']}
                handleIndex={this.handleIndex}
                activeType={this.state.activeType}
              />
              <ContentWrapper>
                <ColumnLeft>
                  <SelectBox
                    selected={this.state.activeDisplayType}
                    label={'Display Plans'}
                    options={plans}
                    onClick={this.handleClickPlans}
                    largeBtn
                    mobile
                  />
                  {this.state.activeDisplayType === 1 && (
                    <SelectBox
                      selected={this.state.activeLevel}
                      label={'Select a Level'}
                      options={
                        this.state.activeType === 0
                          ? suiteLevels
                          : townHomeLevels
                      }
                      onClick={this.handleClickLevel}
                    />
                  )}
                  <SelectBox
                    selected={this.state.activeSuiteType}
                    label={'Home Type'}
                    options={
                      this.state.activeType === 0 ? suiteType : townHomeType
                    }
                    onClick={this.handleClickHomeType}
                  />
                </ColumnLeft>
                <ColumnRight active={this.state.activeDisplayType}>
                  <Floorplate
                    type={this.state.activeType}
                    active={this.state.activeLevel}
                    filter={this.state.activeSuiteType}
                    onClick={this.handleClickFloorplan}
                  />
                </ColumnRight>
                {this.state.activeDisplayType === 0 && (
                  <Thumbnails
                    data={dataFloorplans}
                    activeType={this.state.activeType}
                    handleClick={this.handleClickFloorplan}
                    isActive={this.state.activeDisplayType}
                    filter={this.state.activeSuiteType}
                  />
                )}
              </ContentWrapper>
            </StyledContainer>
          </Content>
        </ScrollAnimation>

        <Popup
          shown={this.state.activePopup}
          currentUnit={this.state.currentUnit}
          closePopup={this.handleClosePopup}
          handlePrevFloorplan={this.handlePrevFloorplan}
          handleNextFloorplan={this.handleNextFloorplan}
          dataFloorplans={dataFloorplans}
        />
        <ScrollAnimation>
          <NextLine link={'/virtualtours'} text={'Next: Virtual Tours'} />
          <RegisterButton />
        </ScrollAnimation>
      </Root>
    );
  }
}

export default Floorplans;

const animateShow = keyframes`
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: flex;
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Root = styled.div`
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
  overflow: hidden;
`;

const BackgroundCircle = styled.img`
  position: absolute;
  top: ${props => props.top && props.top};
  bottom: ${props => props.bottom && props.bottom};
  right: ${props => props.right};
  z-index: -1;
  display: none;
  @media (min-width: ${media.smup}) {
    display: block;
  }
`;

const StyledContainer = styled(Container)`
  padding-top: 80px;
  padding-bottom: 98px;
  max-width: 1260px;
  position: relative;
  h1 {
    text-transform: uppercase;
  }
  .title {
    max-width: 445px;
    margin: 0 auto 45px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ColumnLeft = styled.div`
  width: 100%;
  @media (min-width: ${media.mdup}) {
    width: 27%;
    max-width: 350px;
  }
`;

const ColumnRight = styled.div`
  margin-left: 10%;
  width: 50%;
  height: auto;
  min-width: 661px;
  max-height: 661px;
  background: #f5f5fa;
  border: 5px solid #0b1a27;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  display: ${props => (props.active ? 'flex' : 'none')};
  animation: ${props => props.active && `${animateShow} 0.8s forwards`};
`;



// WEBPACK FOOTER //
// ./src/pages/Floorplans/Floorplans.js